import RatView from './RatView';

export default RatView;
